import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const useInterval = (callback, delay) => {
  const $ = _c(7);
  const savedCallback = useRef(null);
  const [intervalId, setIntervalId] = useState(null);
  let t0;
  if ($[0] !== callback) {
    t0 = () => {
      savedCallback.current = callback;
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  let t1;
  if ($[2] !== delay || $[3] !== intervalId) {
    t1 = () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
      if (delay > 0) {
        const tick = function tick() {
          savedCallback?.current();
        };
        const id = setInterval(tick, delay);
        setIntervalId(id);
        return () => clearInterval(id);
      }
    };
    $[2] = delay;
    $[3] = intervalId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== delay) {
    t2 = [delay];
    $[5] = delay;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
};